module.exports = __webpack_public_path__ + "img/microsoft-excel.4ee64c73.svg";